import { observer } from "mobx-react-lite";
import React, { useEffect, useRef } from "react";
import { useStore } from "../helpers";
import { FormButtons, SideOverlay } from "../components";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { FTPCheckBox, FTPInput } from "../components-new";
import {
  AddButton,
  DeleteButton,
} from "../features/task-manager/task-list-components/Buttons";
import AddSubQuestion from "./add-sub-question";

import { toast } from "react-toastify";
import { createSchema } from "./section-wise-ui-schema";
import { yupResolver } from "@hookform/resolvers/yup";
const OPTION_TYPES_FOR_OTHER_TEXT_BOX = [
  "single-select-other",
  "multi-select-other",
];

const convertOptionsToArray = (data, languages) => {
  const clone = JSON.parse(JSON.stringify(data));

  clone.payload?.sections?.forEach((section, sectionIndex) => {
    section.fields?.forEach((field, fieldIndex) => {
      // console.log(field, "field here")
      // if (field.field_type === "cat-wise") {
      //   field.field_type = JSON.parse(field.options)
      //   return
      // }
      // ---------- HANDLE OPTIONS ----------
      if (field.options) {
        let optionArrays = {};

        //  Convert each language string → array
        languages.forEach((lng) => {
          const value = field.options[lng];

          if (typeof value === "string") {
            const arr = value
              .split("\n")
              .map((x) => x.trim())
              .filter((x) => x.length > 0);

            optionArrays[lng] = arr;
            field.options[lng] = arr;
          } else if (Array.isArray(value)) {
            optionArrays[lng] = value;
          }
        });

        // Validate length mismatch
        // @ts-ignore
        const counts = Object.values(optionArrays).map((a) => a.length);
        const first = counts[0];
        const mismatch = counts.some((c) => c !== first);

        if (mismatch) {
          toast.error(
            `Option count mismatch in Section ${sectionIndex + 1}, Field ${fieldIndex + 1
            }.`
          );

          throw new Error(
            `Option count mismatch in Section ${sectionIndex + 1}, Field ${fieldIndex + 1
            }. All languages must have same number of options.\n\n` +
            JSON.stringify(optionArrays, null, 2)
          );
        }
      }
      if (!OPTION_TYPES_FOR_OTHER_TEXT_BOX.includes(field.field_type)) {
        delete field.other_text;
      }
    });
  });

  return clone;
};

const AddSectionWiseUI = ({ currentQuestion, handleSave, languages }) => {
  const defaultValues = {
    name: "",
    text: {
      ...Object.fromEntries(languages?.map((key) => [key, ""])),
    },
    type: "section-wise",
    payload: {
      sections: [
        {
          key: "",
          is_accordian: false,
          incremental: false,
          name: {
            ...Object.fromEntries(
              languages?.map((key) => [key, ""])
            ),
          },
          fields: [
            {
              key: "",
              name: {
                ...Object.fromEntries(
                  languages?.map((key) => [key, ""])
                ),
              },
              field_type: "",
              options: {
                ...Object.fromEntries(
                  languages?.map((key) => [key, ""])
                ),
              },
              other_text: {
                ...Object.fromEntries(
                  languages?.map((key) => [key, ""])
                ),
              },
              validation: true,
              more: {},
            },
          ],
        },
      ],
    },
  };

  const {
    projectStore: { sectionWiseModal, set_section_wise_modal },
  } = useStore();
  const schema = createSchema(languages);
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });
  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: "payload.sections",
  });
  const toShowAddSection = useRef(null);
  const onSubmit = async (data) => {
    // console.log(data, "submitted data");
    try {
      const cleaned = convertOptionsToArray(data, languages);
      // console.log(cleaned, "options of all");
      await handleSave(JSON.stringify(cleaned));
      set_section_wise_modal(false);
    } catch (error) {
      console.log(error);
    }
  };
  const onError = (error) => {
    // console.log(methods.getValues(), "all values");
    console.log(error);
  };
  useEffect(() => {
    methods.reset(currentQuestion);
  }, [currentQuestion]);
  return (
    <SideOverlay
      show={sectionWiseModal}
      onClose={() => set_section_wise_modal(false)}
      size="5xl"
      title="Add Section Wise Question"
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit, onError)}
          className="bg-white px-4 py-2 rounded-sm flex flex-col gap-y-4"
        >
          <FTPInput label={"Name"} name={"name"} />
          {languages?.map((lng) => {
            return (
              <>
                <FTPInput
                  multiline
                  rows={3}
                  label={lng.toUpperCase()}
                  name={`text.${lng}`}
                />
              </>
            );
          })}
          {fields.map((field, index) => {
            const is_accordian = methods.watch(
              `payload.sections.${index}.is_accordian`
            );
            toShowAddSection.current = is_accordian;
            return (
              <div key={field.id}>

                <h1>Section {index + 1}</h1>
                <FTPInput label={"Section Key"} name={`payload.sections.${index}.key`} />
                <FTPCheckBox
                  label={"Is Accordion"}
                  name={`payload.sections.${index}.is_accordian`}
                />
                <FTPCheckBox
                  label={"Is Incremental"}
                  name={`payload.sections.${index}.incremental`}
                />
                <h1>Main Question</h1>
                <div className="grid grid-cols-2 gap-2">
                  {languages?.map((lng) => {
                    return (
                      <>
                        <FTPInput
                          multiline
                          rows={3}
                          label={lng.toUpperCase()}
                          name={`payload.sections.${index}.name.${lng}`}
                        />
                      </>
                    );
                  })}
                </div>
                <AddSubQuestion
                  languages={languages}
                  methods={methods}
                  sectionIndex={index}
                  key={index}
                />
                {index > 0 && (
                  <DeleteButton
                    text="Remove Section"
                    onClick={() => remove(index)}
                  />
                )}
              </div>
            );
          })}
          {(
            toShowAddSection.current && <AddButton
              text="Add New Section"
              onClick={() =>
                append(
                  {
                    key: "",
                    is_accordian: false,
                    incremental: false,
                    name: {
                      ...Object.fromEntries(languages?.map((key) => [key, ""])),
                    },
                    fields: [
                      {
                        key: "",
                        name: {
                          ...Object.fromEntries(languages?.map((key) => [key, ""])),
                        },
                        field_type: "",
                        options: {
                          ...Object.fromEntries(languages?.map((key) => [key, ""])),
                        },
                        other_text: {
                          ...Object.fromEntries(languages?.map((key) => [key, ""])),
                        },
                        validation: true,
                        more: {},
                      },
                    ],
                  })
              }
            />
          )}

          <FormButtons
            onCancel={() => {
              set_section_wise_modal(false);
            }}
            onSave={() => { }}
          />
        </form>
      </FormProvider>
    </SideOverlay>
  );
};

export default observer(AddSectionWiseUI);
